module.exports = __webpack_public_path__ + "media/images/People-c4ef6ea87b500b592826c1a621ec1b0f.svg";